export default __webpack_public_path__ + "static/media/Hana.fe932c64.png";